import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "enable",
    "fields",
    "integrationOptions",
    "systemSelect",
    "imosFields",
    "dataloyFields",
    "webhookEnable",
    "webhookFields",
    "shared",
    "token",
    "form",
    "saveButton",
    "webhookUrl",
  ]

  static values = {
    companyId: Number,
    apiHost: String,
  }

  connect() {
    this.toggleSystem()
    this.toggleEnabled()
    this.toggleWebhook()
    this.initialFormState = this.serializeForm()
    this.checkDirty()
  }

  toggleEnabled() {
    this.fieldsTarget.classList.toggle("d-none", !this.enableTarget.checked)
    this.updateShared()
  }

  toggleSystem() {
    const system = this.systemSelectTarget.value
    this.integrationOptionsTarget.classList.toggle("d-none", !system)
    this.imosFieldsTarget.classList.toggle("d-none", system !== "IMOS")
    this.dataloyFieldsTarget.classList.toggle("d-none", system !== "Dataloy")
    this.updateWebhookUrl(system)
  }

  toggleWebhook() {
    this.webhookFieldsTarget.classList.toggle("d-none", !this.webhookEnableTarget.checked)
    this.updateShared()
  }

  updateShared() {
    const anyEnabled = this.enableTarget.checked || this.webhookEnableTarget.checked
    this.sharedTarget.classList.toggle("d-none", !anyEnabled)
  }

  updateWebhookUrl(system) {
    this.webhookUrlTarget.textContent = system
      ? `https://${this.apiHostValue}/webhook/${system.toLowerCase()}/${this.companyIdValue}`
      : ""
  }

  generateToken() {
    const bytes = new Uint8Array(32)
    crypto.getRandomValues(bytes)
    this.tokenTarget.value = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("")
    this.checkDirty()
  }

  copyToken() {
    const token = this.tokenTarget.value
    if (!token) return

    navigator.clipboard?.writeText(token)
  }

  copyWebhookUrl() {
    const url = this.webhookUrlTarget.textContent
    if (!url) return

    navigator.clipboard?.writeText(url)
  }

  checkDirty() {
    const dirty = this.serializeForm() !== this.initialFormState
    this.saveButtonTarget.disabled = !dirty
  }

  serializeForm() {
    const formData = new FormData(this.formTarget)
    return Array.from(formData.entries())
      .map(([key, value]) => `${key}=${value}`)
      .join("&")
  }
}
